module.exports = __webpack_public_path__ + "img/ItemMatrix.d087ef6f.jpg";